import { graphql } from "gatsby"
import React from "react"
import AccentTitleDivider from "../../components/shared/accent-title-divider/accent-title-divider"
import SectionDivider from "../../components/shared/section-divider"

export interface IDivider {
  __typename: "ContentfulDivider"
  dividerType: "Title Block" | "Shear Top" | "Shear Bottom" | "Line"
  title?: string
  backgroundColour?: { hex: string }
}

const Divider = ({
  dividerType = "Line",
  title = "Title",
  backgroundColour,
}: Omit<IDivider, "__typename">) => {
  switch (dividerType) {
    case "Title Block":
      //@ts-ignore - not all props required
      return <AccentTitleDivider>{title}</AccentTitleDivider>
    case "Shear Top":
    case "Shear Bottom":
      return (
        <div style={{ backgroundColor: backgroundColour?.hex }}>
          <SectionDivider flip={dividerType === "Shear Bottom"} />
        </div>
      )
    case "Line":
      return (
        <div
          style={{
            backgroundColor: backgroundColour?.hex,
            borderBottom: "1px solid rgba(46, 46, 46, 0.15)",
          }}
        />
      )
    default:
      return null
  }
}

export const SideBySideContentFragment = graphql`
  fragment ContentfulDivider on ContentfulDivider {
    contentful_id
    dividerType
    title: text
    backgroundColour {
      hex
    }
  }
`
export const DIVIDER_TYPENAME = "ContentfulDivider"
export default Divider
